import {PaymentChannel} from "../../../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
export class OnAuthenticatedSession {
  constructor($rootScope, sessionService, naviService, invoicesService) {
    const setSepaChannel = () => {
      const session = sessionService?.session;
      const partnerId = session.currentAccount.id;
      if (partnerId === "FI51POYT0031925356") {
        invoicesService.defaultSepaChannel = PaymentChannel.TalenomManual;
        sessionService.clientRoles.push("palkkausManual");
        naviService.updateSitemapInRole();
      }
    };
    const setRole = () => {
      const session = sessionService?.session;
      const partnerId = session.currentAccount.id;
      if (partnerId === "FI88POYT0025514542") {
        sessionService.clientRoles.push("accountingTargets");
        naviService.updateSitemapInRole();
      }
    };
    if (sessionService.isSessionChecked && sessionService.isAuthenticated) {
      setRole();
      setSepaChannel();
    }
    sessionService.onAuthenticatedSession($rootScope, () => {
      setRole();
      setSepaChannel();
    });
  }
}
OnAuthenticatedSession.$inject = [
  "$rootScope",
  "SessionService",
  "NaviService",
  "InvoicesService"
];
